import makeStyles from '@mui/styles/makeStyles';
import {Container, Typography} from "@mui/material";
import {useLocation, useParams} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {DASH_AWARDS, get, getErrorMessage, getUrl, post, USERS} from "../../services/Client";
import axios from "axios";
import CssBaseline from "@mui/material/CssBaseline";
import logo from "../../images/splash.png"
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	error: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		color: theme.palette.primary.main
	},
	input: {
		'& :-webkit-autofill': {
			'transition-delay': '9999s'
		},
	},
	bold: {
		fontWeight:"bold",
		marginTop:"1em"
	}
}))

export default function ConfirmFormComplete() {

	const {t} = useTranslation();
	const classes = useStyles();
	const [message, setMessage] = useState()
	const [award, setAward] = useState()
	const [description, setDescription] = useState()
	const {search} = useLocation()
	let {aid} = useParams();

	const query= useMemo(() => {
		return new URLSearchParams(search);
	}, [search])

	useEffect(()=> {
		let email = query.get("e") || "";
		axios.get(getUrl(`${USERS}/${email.trim().toLocaleLowerCase()}/profile`)).then(({data}) => {
			setMessage(`${t('thanks')}, ${data.firstName} ${data.lastName} ${t('forParticipating')}`)
			axios.post(getUrl(`${DASH_AWARDS}/custom-users?uid=${data.uid}&aid=${aid}`))
				.then(({data}) => {
					if(data.name) {
						setAward(data.name);
						setDescription(data.description);
					}
					else setAward(t('awardAlreadyRedeemed'))
				})
				.catch(e => setAward(t('awardAlreadyRedeemed')));
		}).catch(e => {
			setMessage(t('emailNotFound'))
		})
	}, [query])

	return (
        <Container component="main" maxWidth="xs">
			<CssBaseline />
			<div className={classes.paper}>
				<img className={classes.avatar} alt={"home"} src={logo}/>
				<Typography component="h1" variant="h5">
					{t('surveyCompleted')}
				</Typography>
				<Typography component={'h3'} variant="h6" align={'center'}>
					{message}
				</Typography>
				<Typography component={'h5'} variant="h6" align={'center'} className={classes.bold}>
					<b>{award}</b>
				</Typography>
				<Typography component={'h5'} variant="h6" align={'center'} >
					{description}
				</Typography>
			</div>
		</Container>
    );
}
